import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Component({
  selector: 'page-unit-reports',
  templateUrl: 'unit-reports.html'
})
export class UnitReportsPage {

  unit: any;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public iab: InAppBrowser
  ) {
    this.unit = navParams.get('unit');
  }

  openFile(file){
    if(file.download_url){
      this.iab.create(file.download_url, '_system');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/unit-reports/unit-reports.ts